<template>
  <div class="home" ref="home">
    <div class="container1 row">
      <div class="upload_container" ref="upload_container" v-bind:style="{ 'border-color': border_color }" :disabled="!loaded">
        <div class="file-wrapper" v-bind:style="{ 'background-color': color, 'color': textColor}">
          <input ref="fileInput" type="file" name="file-input" multiple="true" @change="(e) => {handleFileInput(e);}" > Click to add files.
        </div>
      </div>

      <div class="filenameInput">
        <label>Filename: </label>
        <input ref="newName" type="text" @input="emitName" :value="name">
        <br>
        <a ref="errorLog" class="errorLog"></a>
      </div>
       <button class="generateButton" ref="generateButton" @click="convert" :disabled="!loaded">Generate</button>
    </div>
    <div class="container2 row">
      <button class="clearButton" ref="clearButton" @click="clearFiles" >Clear files</button>
    </div>
  </div>
</template>

<script>
import ModuleTest from '../wasm/NftMarkerCreator.min.js';

export default {
  name: 'Home',
  components: {
  },
  data(){
    return{
      files: null,
      fileContents: null,
      loaded: false,
      filename: null,
      name: null,
      color: 'white',
      border_color: 'black',
      textColor: 'black',
    }
  },
  methods: {
    clearFiles(){
      console.log("Cleared Input Files")
      this.$refs["fileInput"].value = "";

      this.$refs["upload_container"].style.pointerEvents = "auto";
      this.$refs["upload_container"].style.opacity = "1";

      this.$refs["errorLog"].textContent = "";

      this.loaded = false;
    },
    async handleFileInput(e) {
      this.files = e.target.files;
      
      try {
        this.fileContents = await this.addFiles(this.files);
        console.log("contents: ",this.fileContents);
        if(this.checkFilesExt(this.fileContents)){
          this.$refs["errorLog"].textContent = "Files are different! Extension, name or missing one."
          throw "Invalid file";
        }else{
          this.$refs["upload_container"].style.pointerEvents = "none";
          this.$refs["upload_container"].style.opacity = "0.5";
          this.loaded = true;
        }  
      } catch (e) {
          console.error(e)
      }
    },
    convert(){
      this.compressZip(this.fileContents);
    },
    addFiles(files) {
      return Promise.all([].map.call(files, function (file) {
          return new Promise(function (resolve) {
            var reader = new FileReader();
            reader.onloadend = function () {
              resolve({ result: reader.result, file: file });
            };
            reader.readAsArrayBuffer(file);
          });
      })).then(function (results) {
        return results;
      });
    },
    checkFilesExt(arrBuff){
      let invalid = false;
      let sameName = [];
      for(let i=0; i < arrBuff.length; i++){
        let name = arrBuff[i].file.name;
        let dot = name.indexOf('.');
        let ext = name.slice(dot+1);
        this.name = name.slice(0, dot);
        sameName.push(name.slice(0, dot));
        if(ext != "iset" && ext != "fset" && ext != "fset3"){
          invalid = true;
          break;
        }
      }

      if(sameName[0] != sameName[1] || sameName[0] != sameName[2]){
        invalid = true;
      }
      return invalid
    } ,
    compressZip(arrBuff){
      let obj = {
          iset: "a",
          fset: "b",
          fset3: "c"
      }

      for(let i=0; i < arrBuff.length; i++){
          let name = arrBuff[i].file.name;
          let dot = name.indexOf('.');
          let ext = name.slice(dot+1);
          let hex = this.buf2hex(arrBuff[i].result);
          obj[ext] = hex;
      }
      
      let strObj = JSON.stringify(obj);

      let StrBuffer = this.$NFTmodule._malloc(strObj.length + 1);
      this.$NFTmodule.writeStringToMemory(strObj, StrBuffer);
      
      this.$NFTmodule._compressZip(StrBuffer, strObj.length);

      let content = this.$NFTmodule.FS.readFile("tempBinFile.bin");

      let newFilename = this.name;

      if(this.userFilename != null){
        newFilename = this.userFilename;
      }
      
      var a = document.createElement('a');
      a.download = newFilename + ".zft";
      a.href = URL.createObjectURL(new Blob([content], { type: "application/octet-stream" }));
      a.style.display = 'none';

      document.body.appendChild(a);
      a.click();

      this.$NFTmodule._free(StrBuffer);
    },
    buf2hex(buffer) {
      return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
    },
    emitName(e){
      this.filename = e.target.value;
      console.log(this.filename);
    }
  },
  beforeCreate(){
    if (this.$NFTmodule === null) {
      new ModuleTest().then(myModule => {
        this.$NFTmodule = myModule;
      });
    }

  },
}
</script>

<style scoped>
.home{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.filenameInput{
  margin: 10px;
}
.errorLog{
  color: red;
  font-weight: bolder;
  font-size: 15px;
}

/* ROWS */
.row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
/* UPLOAD CONTAINER */
.upload_container{
  border-style: dashed;
  border-radius: 5px;
  font-size: 2em;
}
.file-wrapper {
  text-align: center;
  width: 350px;
  height: 350px;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
}
.file-wrapper input {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    opacity: 0.0;
    filter: alpha(opacity=0);
    font-size: 300px;
    height: 100%;
}
/* CANVAS */
.canvas_preview{
  width: 350px;
  height: 350px;
  border-style: dashed;
  border-radius: 5px;
}
.canvas_image{
  display: none;
}
/* BUTTONS */
.clearButton{
  margin: 10px;
  font-weight: bold;
  padding: 10px;
  color: red;
  background-color: transparent;
  border-style: solid;
  border-color: red;
  border-radius: 10px;
}
.clearButton:hover{
  background-color: #e57e7e;
  cursor: pointer;
}
.clearButton:active, .clearButton:focus {
  outline: 0;
  /* border: none; */
  -moz-outline-style: none;
}
.clearButton:disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.4;
}
.generateButton{
  width: 200px;
  height: 350px;
  font-weight: bold;
  color: #42b983;
  background-color: transparent;
  border-style: dashed;
  border-color: #42b983;
  border-radius: 10px;
  font-size: 25px;
}
.generateButton:hover{
  background-color: #8dd5b4;
  cursor: pointer;
  color: white;
}
.generateButton:active, .generateButton:focus {
  outline: 0;
  /* border: none; */
  -moz-outline-style: none; 
}
.generateButton:disabled {
  border-color: red;
  color: red;
  pointer-events: none;
  cursor: default;
}
</style>
